(function () {
  var TOAST_ID = 'med7-added-to-cart-toast';
  var STYLE_ID = 'med7-added-to-cart-toast-style';
  var VISIBLE_MS = 5000;
  var hideTimer = null;

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var styleEl = document.createElement('style');
    styleEl.id = STYLE_ID;
    styleEl.textContent =
      '.med7-added-to-cart-toast{' +
        'position:fixed;left:50%;top:16px;transform:translate(-50%,-12px);' +
        'width:max-content;max-width:25vw;background:#E3F6FD;color:#00647F;' +
        'border-radius:10px;padding:14px 18px;' +
        'box-shadow:0 6px 24px rgba(0,0,0,0.15);z-index:99999;' +
        'display:flex;align-items:center;gap:12px;' +
        'opacity:0;pointer-events:none;transition:opacity .25s ease,transform .25s ease;' +
      '}' +
      '.med7-added-to-cart-toast.is-visible{opacity:1;transform:translate(-50%,0);pointer-events:auto;}' +
      '@media (max-width:767px){.med7-added-to-cart-toast{max-width:80vw;}}' +
      '.med7-added-to-cart-toast__icon{width:20px;height:20px;flex-shrink:0;fill:#00647F;}' +
      '.med7-added-to-cart-toast__text{margin:0;font-size:14px;font-weight:500;flex:1;min-width:0;}' +
      '.med7-added-to-cart-toast__link{margin:0;font-size:14px;font-weight:700;color:#00647F;' +
        'text-decoration:underline;white-space:nowrap;flex-shrink:0;}';
    document.head.appendChild(styleEl);
  }

  function ensureToast() {
    var toast = document.getElementById(TOAST_ID);
    if (toast) return toast;
    toast = document.createElement('div');
    toast.id = TOAST_ID;
    toast.className = 'med7-added-to-cart-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<svg class="med7-added-to-cart-toast__icon" viewBox="0 0 512 512" aria-hidden="true">' +
        '<path d="M256,0C114.8,0,0,114.8,0,256s114.8,256,256,256s256-114.8,256-256S397.2,0,256,0z M385.7,201.7L247.1,340.4' +
        'c-4.2,4.2-9.6,6.3-15.1,6.3c-5.5,0-10.9-2.1-15.1-6.3l-69.3-69.3c-8.3-8.3-8.3-21.8,0-30.2c8.3-8.3,21.8-8.3,30.2,0l54.3,54.3' +
        'l123.6-123.6c8.3-8.3,21.8-8.3,30.2,0C394.1,179.9,394.1,193.4,385.7,201.7L385.7,201.7z"/>' +
      '</svg>' +
      '<p class="med7-added-to-cart-toast__text" dir="auto"></p>' +
      '<a class="med7-added-to-cart-toast__link" dir="auto"></a>';
    document.body.appendChild(toast);
    return toast;
  }

  function hide() {
    var toast = document.getElementById(TOAST_ID);
    if (toast) toast.classList.remove('is-visible');
    clearTimeout(hideTimer);
  }

  // Always the same generic message, whether the product was newly added or its
  // quantity was updated by adding it again — per spec, no product-specific content.
  window.med7ShowAddedToCartToast = function () {
    var message  = (window.cartStrings && window.cartStrings.itemAdded) || '';
    if (!message) return;

    ensureStyle();
    var toast = ensureToast();
    toast.querySelector('.med7-added-to-cart-toast__text').textContent = message;

    var linkEl = toast.querySelector('.med7-added-to-cart-toast__link');
    var viewCartText = (window.cartStrings && window.cartStrings.viewCart) || '';
    var cartUrl       = (window.routes && window.routes.cart_url) || '/cart';
    linkEl.textContent = viewCartText;
    linkEl.href = cartUrl;
    linkEl.hidden = !viewCartText;

    toast.classList.remove('is-visible');
    void toast.offsetWidth; // force reflow so a repeated call restarts the transition
    toast.classList.add('is-visible');

    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, VISIBLE_MS);
  };
})();
